import React, { useEffect, useState } from "react";
import * as Yup from "yup";

import { Typography, Box, TextField, Container } from "@mui/material";
import { PrimaryButton, SecondaryButton } from "../../../common/Buttons";
import { Form, Formik } from "formik";
import {
  getHealthcareProxy,
  postHealthcareProxy,
} from "../../../services/documentServices";
import { toast } from "react-hot-toast";
import InputField from "../../../common/InputField";
import { getUserIdFromLocalStorage } from "../../../utils/Utilities";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";

function Signature(props) {
  const { t } = useTranslation();
  let uID = getUserIdFromLocalStorage();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [initialValues, setInitialValues] = useState({
    place: "",
  });

  async function fetchData() {
    setIsLoading(true);
    try {
      const result = await getHealthcareProxy(uID);
      if (result?.success && result?.payLoad) {
        setData(result.payLoad);
        setInitialValues({
          place: result.payLoad.place,
        });
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmit = async (values) => {
    props.setButtonDisabled(true);
    const { place } = values;
    const payload = {
      ...data,
      place,
    };
    const result = await postHealthcareProxy(payload, uID);
    if (result?.success) {
      // toast.success(
      //   t(
      //     result?.message
      //       .toLowerCase()
      //       .replaceAll(" ", "-")
      //       .replaceAll("/", "-")
      //       .replaceAll(",", "")
      //       .replaceAll("'", "")
      //   )
      // );
      props.next();
    }
    props.setButtonDisabled(false);
  };
  const handleDateOfBirthKeyDown = (event) => {
    event.preventDefault();
  };
  return (
    <>
      <Container maxWidth="xs">
        {isLoading ? (
          <Box component="div" className="loader-container">
            <Circles color="#dfc8db" height={80} width={80} />
          </Box>
        ) : (
          <Formik
            initialValues={initialValues}
            enableReinitialize
            onSubmit={(values) => {
              handleSubmit(values);
            }}
          >
            {(formik) => {
              return (
                <Form id="form_submit" onSubmit={formik.handleSubmit}>
                  <Box sx={{ mt: 5, textAlign: "center" }}>
                    <Typography
                      sx={{ mt: 5 }}
                      variant="p"
                      paragraph
                      align="left"
                      color="color.black"
                    >
                      {t("input-20")}
                    </Typography>

                    <InputField
                      fullWidth
                      variant="standard"
                      placeholder="Karlsruhe, 15th March 2022"
                      name="place"
                      type="date"
                      value={formik.values.place}
                      onChange={(newValue) => {
                        formik.setFieldValue("place", newValue);
                      }}
                      onFocus={(e) => (e.target.type = "date")}
                      onKeyDown={handleDateOfBirthKeyDown}
                    />

                    <Typography
                      sx={{ mt: 5 }}
                      variant="p"
                      paragraph
                      align="left"
                      color="color.black"
                    >
                      {t("doc-tab-3")}
                    </Typography>

                    <Typography
                      sx={{ mt: 5 }}
                      variant="p"
                      paragraph
                      align="center"
                      color="color.black"
                      fontStyle="italic"
                    >
                      {t("please-sign")}
                    </Typography>
                    <TextField
                      fullWidth
                      variant="standard"
                      name="sign"
                      type="text"
                      sx={{
                        pointerEvents: "none",
                      }}
                    />
                  </Box>
                </Form>
              );
            }}
          </Formik>
        )}
      </Container>
    </>
  );
}

export default Signature;
